import { inject, Injectable } from "@angular/core";
import { UserLocalStorageService } from "../local-storage-services/user-local-storage.service";
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';


@Injectable({
    providedIn: 'root'
})
export class UserStorageService
{
    private readonly _userLocalStorageService = injectRequired(UserLocalStorageService);

    // True zodra de user-scope gehydrateerd is; schrijvers/lezers van user-storage moeten hierop wachten
    // (zie PageStorageService.hydrated$$ voor hetzelfde patroon op page-/tab-niveau).
    readonly hydrated$$ = this._userLocalStorageService.hydrated$$;

    domainProfileData$$ = this._userLocalStorageService.domainProfileData$$;
    pageStart$$ = this._userLocalStorageService.pageStart$$;

    pageStart_forGuid(userGuid: string) {
        return this._userLocalStorageService.pageStart_forGuid(userGuid);
    }
}